import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    // Sidebar
    nav_dashboard: 'Dashboard',
    nav_leave_dashboard: 'Leave Dashboard',
    nav_my_profile: 'My Profile',
    nav_analytics: 'Analytics',
    nav_approvals: 'Approvals',
    nav_staff_directory: 'Staff Directory',
    nav_org_chart: 'Org Chart',
    nav_team_calendar: 'Team Calendar',
    nav_staff_management: 'Staff Management',
    nav_leave_policies: 'Leave Policies',
    nav_holidays: 'Holiday Calendar',
    nav_work_schedule: 'Work Schedule',
    nav_workflows: 'Workflows',
    nav_school_branding: 'School Branding',
    nav_announcements: 'Announcements',
    nav_billing: 'Billing',
    nav_documents: 'Documents',
    navigation: 'Navigation',
    // Header
    logout: 'Logout',
    language: 'Language',
    notifications: 'Notifications',
    mark_all_read: 'Mark all read',
    no_notifications: 'No notifications yet',
    // Dashboard
    welcome_back: 'Welcome back',
    school_overview: "Here's what's happening in your school",
    your_leave_balance: 'Your leave balance and requests',
    total_staff: 'Total Staff',
    pending_requests: 'Pending Requests',
    awaiting_approval: 'Awaiting approval',
    approved: 'Approved',
    rejected: 'Rejected',
    this_month: 'This month',
    active: 'active',
    your_leave_balance_title: 'Your Leave Balance',
    used: 'Used',
    pending: 'Pending',
    // Leave Dashboard
    leave_dashboard: 'Leave Dashboard',
    manage_track_leaves: 'Manage and track your leaves',
    apply_for_leave: 'Apply for Leave',
    team_calendar: 'Team Calendar',
    on_leave_today: 'On Leave Today',
    my_recent_requests: 'My Recent Requests',
    no_leave_requests: 'No leave requests yet',
    no_one_on_leave: 'No one is on leave today',
    submit_request: 'Submit Request',
    submitting: 'Submitting...',
    leave_type: 'Leave Type',
    start_date: 'Start Date',
    end_date: 'End Date',
    reason: 'Reason',
    reason_placeholder: 'Reason for leave...',
    // Leave Types
    sick_leave: 'Sick Leave',
    casual_leave: 'Casual Leave',
    vacation: 'Vacation',
    earned_leave: 'Earned Leave',
    maternity_leave: 'Maternity',
    paternity_leave: 'Paternity',
    unpaid_leave: 'Unpaid',
    compensatory: 'Comp Off',
    // Announcements
    announcements: 'Announcements',
    manage_announcements: 'Manage school announcements',
    create_announcement: 'Create Announcement',
    announcement_title: 'Title',
    announcement_message: 'Message',
    priority: 'Priority',
    publish: 'Publish',
    publishing: 'Publishing...',
    active_announcements: 'Active Announcements',
    past_announcements: 'Past Announcements',
    no_announcements: 'No announcements yet',
    delete: 'Delete',
    info: 'Info',
    warning: 'Warning',
    urgent: 'Urgent',
    // Org Chart
    organization_chart: 'Organization Chart',
    members: 'members',
    expand_all: 'Expand All',
    collapse: 'Collapse',
    all_departments: 'All Departments',
    click_node_info: 'Click any node to see quick info',
    view_full_profile: 'View Full Profile',
    // Common
    save_changes: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    edit: 'Edit',
    search: 'Search',
    loading: 'Loading...',
    back: 'Back',
    no_data: 'No data found',
  },
  hi: {
    nav_dashboard: 'डैशबोर्ड',
    nav_leave_dashboard: 'छुट्टी डैशबोर्ड',
    nav_my_profile: 'मेरी प्रोफाइल',
    nav_analytics: 'विश्लेषण',
    nav_approvals: 'अनुमोदन',
    nav_staff_directory: 'कर्मचारी सूची',
    nav_org_chart: 'संगठन चार्ट',
    nav_team_calendar: 'टीम कैलेंडर',
    nav_staff_management: 'कर्मचारी प्रबंधन',
    nav_leave_policies: 'छुट्टी नीतियां',
    nav_holidays: 'छुट्टी कैलेंडर',
    nav_work_schedule: 'कार्य अनुसूची',
    nav_workflows: 'कार्यप्रवाह',
    nav_school_branding: 'स्कूल ब्रांडिंग',
    nav_announcements: 'घोषणाएं',
    nav_billing: 'बिलिंग',
    nav_documents: 'दस्तावेज़',
    navigation: 'नेविगेशन',
    logout: 'लॉगआउट',
    language: 'भाषा',
    notifications: 'सूचनाएं',
    mark_all_read: 'सभी पढ़ा हुआ',
    no_notifications: 'कोई सूचना नहीं',
    welcome_back: 'वापसी पर स्वागत',
    school_overview: 'आपके स्कूल में क्या हो रहा है',
    your_leave_balance: 'आपकी छुट्टी शेष और अनुरोध',
    total_staff: 'कुल कर्मचारी',
    pending_requests: 'लंबित अनुरोध',
    awaiting_approval: 'अनुमोदन की प्रतीक्षा',
    approved: 'स्वीकृत',
    rejected: 'अस्वीकृत',
    this_month: 'इस महीने',
    active: 'सक्रिय',
    your_leave_balance_title: 'आपकी छुट्टी शेष',
    used: 'उपयोग किया',
    pending: 'लंबित',
    leave_dashboard: 'छुट्टी डैशबोर्ड',
    manage_track_leaves: 'अपनी छुट्टियों का प्रबंधन करें',
    apply_for_leave: 'छुट्टी के लिए आवेदन',
    team_calendar: 'टीम कैलेंडर',
    on_leave_today: 'आज छुट्टी पर',
    my_recent_requests: 'मेरे हालिया अनुरोध',
    no_leave_requests: 'अभी कोई छुट्टी अनुरोध नहीं',
    no_one_on_leave: 'आज कोई छुट्टी पर नहीं',
    submit_request: 'अनुरोध जमा करें',
    submitting: 'जमा हो रहा है...',
    leave_type: 'छुट्टी का प्रकार',
    start_date: 'प्रारंभ तिथि',
    end_date: 'समाप्ति तिथि',
    reason: 'कारण',
    reason_placeholder: 'छुट्टी का कारण...',
    sick_leave: 'बीमारी की छुट्टी',
    casual_leave: 'आकस्मिक छुट्टी',
    vacation: 'अवकाश',
    earned_leave: 'अर्जित छुट्टी',
    maternity_leave: 'मातृत्व छुट्टी',
    paternity_leave: 'पितृत्व छुट्टी',
    unpaid_leave: 'बिना वेतन छुट्टी',
    compensatory: 'प्रतिपूरक छुट्टी',
    announcements: 'घोषणाएं',
    manage_announcements: 'स्कूल घोषणाएं प्रबंधित करें',
    create_announcement: 'घोषणा बनाएं',
    announcement_title: 'शीर्षक',
    announcement_message: 'संदेश',
    priority: 'प्राथमिकता',
    publish: 'प्रकाशित करें',
    publishing: 'प्रकाशित हो रहा है...',
    active_announcements: 'सक्रिय घोषणाएं',
    past_announcements: 'पुरानी घोषणाएं',
    no_announcements: 'कोई घोषणा नहीं',
    delete: 'हटाएं',
    info: 'सूचना',
    warning: 'चेतावनी',
    urgent: 'तत्काल',
    organization_chart: 'संगठन चार्ट',
    members: 'सदस्य',
    expand_all: 'सभी विस्तार करें',
    collapse: 'संक्षिप्त करें',
    all_departments: 'सभी विभाग',
    click_node_info: 'जानकारी के लिए किसी नोड पर क्लिक करें',
    view_full_profile: 'पूरी प्रोफाइल देखें',
    save_changes: 'परिवर्तन सहेजें',
    saving: 'सहेजा जा रहा है...',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    search: 'खोजें',
    loading: 'लोड हो रहा है...',
    back: 'वापस',
    no_data: 'कोई डेटा नहीं मिला',
  },
  kn: {
    nav_dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    nav_leave_dashboard: 'ರಜಾ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    nav_my_profile: 'ನನ್ನ ಪ್ರೊಫೈಲ್',
    nav_analytics: 'ವಿಶ್ಲೇಷಣೆ',
    nav_approvals: 'ಅನುಮೋದನೆಗಳು',
    nav_staff_directory: 'ಸಿಬ್ಬಂದಿ ಪಟ್ಟಿ',
    nav_org_chart: 'ಸಂಸ್ಥೆ ಚಾರ್ಟ್',
    nav_team_calendar: 'ತಂಡ ಕ್ಯಾಲೆಂಡರ್',
    nav_staff_management: 'ಸಿಬ್ಬಂದಿ ನಿರ್ವಹಣೆ',
    nav_leave_policies: 'ರಜಾ ನೀತಿಗಳು',
    nav_workflows: 'ಕಾರ್ಯ ಹರಿವು',
    nav_school_branding: 'ಶಾಲಾ ಬ್ರಾಂಡಿಂಗ್',
    nav_announcements: 'ಪ್ರಕಟಣೆಗಳು',
    nav_billing: 'ಬಿಲ್ಲಿಂಗ್',
    nav_documents: 'ದಾಖಲೆಗಳು',
    navigation: 'ನ್ಯಾವಿಗೇಶನ್',
    logout: 'ಲಾಗ್ಔಟ್',
    language: 'ಭಾಷೆ',
    notifications: 'ಅಧಿಸೂಚನೆಗಳು',
    mark_all_read: 'ಎಲ್ಲವನ್ನೂ ಓದಿದೆ',
    no_notifications: 'ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',
    welcome_back: 'ಮರಳಿ ಸ್ವಾಗತ',
    school_overview: 'ನಿಮ್ಮ ಶಾಲೆಯಲ್ಲಿ ಏನಾಗುತ್ತಿದೆ',
    your_leave_balance: 'ನಿಮ್ಮ ರಜಾ ಬಾಕಿ ಮತ್ತು ವಿನಂತಿಗಳು',
    total_staff: 'ಒಟ್ಟು ಸಿಬ್ಬಂದಿ',
    pending_requests: 'ಬಾಕಿ ವಿನಂತಿಗಳು',
    awaiting_approval: 'ಅನುಮೋದನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
    approved: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
    rejected: 'ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
    this_month: 'ಈ ತಿಂಗಳು',
    active: 'ಸಕ್ರಿಯ',
    your_leave_balance_title: 'ನಿಮ್ಮ ರಜಾ ಬಾಕಿ',
    used: 'ಬಳಸಿದ',
    pending: 'ಬಾಕಿ',
    leave_dashboard: 'ರಜಾ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    manage_track_leaves: 'ನಿಮ್ಮ ರಜೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
    apply_for_leave: 'ರಜೆಗೆ ಅರ್ಜಿ',
    team_calendar: 'ತಂಡ ಕ್ಯಾಲೆಂಡರ್',
    on_leave_today: 'ಇಂದು ರಜೆಯಲ್ಲಿ',
    my_recent_requests: 'ನನ್ನ ಇತ್ತೀಚಿನ ವಿನಂತಿಗಳು',
    no_leave_requests: 'ಇನ್ನೂ ರಜಾ ವಿನಂತಿಗಳಿಲ್ಲ',
    no_one_on_leave: 'ಇಂದು ಯಾರೂ ರಜೆಯಲ್ಲಿಲ್ಲ',
    submit_request: 'ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
    submitting: 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
    leave_type: 'ರಜಾ ಪ್ರಕಾರ',
    start_date: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
    end_date: 'ಅಂತಿಮ ದಿನಾಂಕ',
    reason: 'ಕಾರಣ',
    reason_placeholder: 'ರಜೆಯ ಕಾರಣ...',
    sick_leave: 'ಅನಾರೋಗ್ಯ ರಜೆ', casual_leave: 'ಸಾಂದರ್ಭಿಕ ರಜೆ', vacation: 'ರಜಾ ದಿನ', earned_leave: 'ಗಳಿಕೆ ರಜೆ', maternity_leave: 'ಹೆರಿಗೆ ರಜೆ', paternity_leave: 'ಪಿತೃತ್ವ ರಜೆ', unpaid_leave: 'ವೇತನರಹಿತ ರಜೆ', compensatory: 'ಪರಿಹಾರ ರಜೆ',
    announcements: 'ಪ್ರಕಟಣೆಗಳು', manage_announcements: 'ಶಾಲಾ ಪ್ರಕಟಣೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ', create_announcement: 'ಪ್ರಕಟಣೆ ರಚಿಸಿ', announcement_title: 'ಶೀರ್ಷಿಕೆ', announcement_message: 'ಸಂದೇಶ', priority: 'ಆದ್ಯತೆ', publish: 'ಪ್ರಕಟಿಸಿ', publishing: 'ಪ್ರಕಟಿಸಲಾಗುತ್ತಿದೆ...', active_announcements: 'ಸಕ್ರಿಯ ಪ್ರಕಟಣೆಗಳು', past_announcements: 'ಹಿಂದಿನ ಪ್ರಕಟಣೆಗಳು', no_announcements: 'ಯಾವುದೇ ಪ್ರಕಟಣೆಗಳಿಲ್ಲ', delete: 'ಅಳಿಸಿ', info: 'ಮಾಹಿತಿ', warning: 'ಎಚ್ಚರಿಕೆ', urgent: 'ತುರ್ತು',
    organization_chart: 'ಸಂಸ್ಥೆ ಚಾರ್ಟ್', members: 'ಸದಸ್ಯರು', expand_all: 'ಎಲ್ಲವನ್ನೂ ವಿಸ್ತರಿಸಿ', collapse: 'ಕುಗ್ಗಿಸಿ', all_departments: 'ಎಲ್ಲಾ ವಿಭಾಗಗಳು', click_node_info: 'ಮಾಹಿತಿಗಾಗಿ ಯಾವುದೇ ನೋಡ್ ಕ್ಲಿಕ್ ಮಾಡಿ', view_full_profile: 'ಸಂಪೂರ್ಣ ಪ್ರೊಫೈಲ್ ನೋಡಿ',
    save_changes: 'ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ', saving: 'ಉಳಿಸಲಾಗುತ್ತಿದೆ...', cancel: 'ರದ್ದುಮಾಡಿ', edit: 'ಸಂಪಾದಿಸಿ', search: 'ಹುಡುಕಿ', loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...', back: 'ಹಿಂದೆ', no_data: 'ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ',
  },
  ta: {
    nav_dashboard: 'டாஷ்போர்டு',
    nav_leave_dashboard: 'விடுப்பு டாஷ்போர்டு',
    nav_my_profile: 'என் சுயவிவரம்',
    nav_analytics: 'பகுப்பாய்வு',
    nav_approvals: 'ஒப்புதல்கள்',
    nav_staff_directory: 'ஊழியர் பட்டியல்',
    nav_org_chart: 'நிறுவன வரைபடம்',
    nav_team_calendar: 'குழு நாட்காட்டி',
    nav_staff_management: 'ஊழியர் மேலாண்மை',
    nav_leave_policies: 'விடுப்பு கொள்கைகள்',
    nav_workflows: 'பணிப்பாய்வுகள்',
    nav_school_branding: 'பள்ளி பிராண்டிங்',
    nav_announcements: 'அறிவிப்புகள்',
    nav_billing: 'பில்லிங்',
    nav_documents: 'ஆவணங்கள்',
    navigation: 'வழிசெலுத்தல்',
    logout: 'வெளியேறு',
    language: 'மொழி',
    notifications: 'அறிவிப்புகள்',
    mark_all_read: 'அனைத்தும் படித்தது',
    no_notifications: 'அறிவிப்புகள் எதுவும் இல்லை',
    welcome_back: 'மீண்டும் வரவேற்கிறோம்',
    school_overview: 'உங்கள் பள்ளியில் என்ன நடக்கிறது',
    your_leave_balance: 'உங்கள் விடுப்பு இருப்பு',
    total_staff: 'மொத்த ஊழியர்கள்',
    pending_requests: 'நிலுவை கோரிக்கைகள்',
    awaiting_approval: 'ஒப்புதலுக்காக காத்திருக்கிறது',
    approved: 'ஒப்புதல் அளிக்கப்பட்டது',
    rejected: 'நிராகரிக்கப்பட்டது',
    this_month: 'இந்த மாதம்',
    active: 'செயலில்',
    your_leave_balance_title: 'உங்கள் விடுப்பு இருப்பு',
    used: 'பயன்படுத்தியது', pending: 'நிலுவையில்',
    leave_dashboard: 'விடுப்பு டாஷ்போர்டு', manage_track_leaves: 'உங்கள் விடுப்புகளை நிர்வகிக்கவும்', apply_for_leave: 'விடுப்பு விண்ணப்பிக்க', team_calendar: 'குழு நாட்காட்டி', on_leave_today: 'இன்று விடுப்பில்', my_recent_requests: 'என் சமீபத்திய கோரிக்கைகள்', no_leave_requests: 'விடுப்பு கோரிக்கைகள் இல்லை', no_one_on_leave: 'இன்று யாரும் விடுப்பில் இல்லை', submit_request: 'கோரிக்கை சமர்ப்பிக்க', submitting: 'சமர்ப்பிக்கிறது...', leave_type: 'விடுப்பு வகை', start_date: 'தொடக்க தேதி', end_date: 'முடிவு தேதி', reason: 'காரணம்', reason_placeholder: 'விடுப்புக்கான காரணம்...',
    sick_leave: 'நோய் விடுப்பு', casual_leave: 'சாதாரண விடுப்பு', vacation: 'விடுமுறை', earned_leave: 'சம்பாதித்த விடுப்பு', maternity_leave: 'மகப்பேறு விடுப்பு', paternity_leave: 'தந்தை விடுப்பு', unpaid_leave: 'சம்பளமில்லா விடுப்பு', compensatory: 'ஈடு விடுப்பு',
    announcements: 'அறிவிப்புகள்', manage_announcements: 'பள்ளி அறிவிப்புகளை நிர்வகிக்கவும்', create_announcement: 'அறிவிப்பு உருவாக்கு', announcement_title: 'தலைப்பு', announcement_message: 'செய்தி', priority: 'முன்னுரிமை', publish: 'வெளியிடு', publishing: 'வெளியிடுகிறது...', active_announcements: 'செயலில் உள்ள அறிவிப்புகள்', past_announcements: 'முந்தைய அறிவிப்புகள்', no_announcements: 'அறிவிப்புகள் இல்லை', delete: 'நீக்கு', info: 'தகவல்', warning: 'எச்சரிக்கை', urgent: 'அவசரம்',
    organization_chart: 'நிறுவன வரைபடம்', members: 'உறுப்பினர்கள்', expand_all: 'அனைத்தையும் விரிவாக்கு', collapse: 'சுருக்கு', all_departments: 'அனைத்து துறைகள்', click_node_info: 'தகவலுக்கு எந்த முனையையும் கிளிக் செய்யவும்', view_full_profile: 'முழு சுயவிவரம் பார்',
    save_changes: 'மாற்றங்களைச் சேமி', saving: 'சேமிக்கிறது...', cancel: 'ரத்து செய்', edit: 'திருத்து', search: 'தேடு', loading: 'ஏற்றுகிறது...', back: 'பின்', no_data: 'தரவு கிடைக்கவில்லை',
  },
  mr: {
    nav_dashboard: 'डॅशबोर्ड', nav_leave_dashboard: 'रजा डॅशबोर्ड', nav_my_profile: 'माझी प्रोफाइल', nav_analytics: 'विश्लेषण', nav_approvals: 'मंजुरी', nav_staff_directory: 'कर्मचारी यादी', nav_org_chart: 'संस्था चार्ट', nav_team_calendar: 'टीम कॅलेंडर', nav_staff_management: 'कर्मचारी व्यवस्थापन', nav_leave_policies: 'रजा धोरणे', nav_workflows: 'कार्यप्रवाह', nav_school_branding: 'शाळा ब्रँडिंग', nav_announcements: 'सूचना', nav_billing: 'बिलिंग', nav_documents: 'दस्तऐवज', navigation: 'नॅव्हिगेशन',
    logout: 'बाहेर पडा', language: 'भाषा', notifications: 'सूचना', mark_all_read: 'सर्व वाचले', no_notifications: 'कोणतीही सूचना नाही',
    welcome_back: 'पुन्हा स्वागत', school_overview: 'तुमच्या शाळेत काय चालले आहे', your_leave_balance: 'तुमची रजा शिल्लक', total_staff: 'एकूण कर्मचारी', pending_requests: 'प्रलंबित विनंत्या', awaiting_approval: 'मंजुरीच्या प्रतीक्षेत', approved: 'मंजूर', rejected: 'नाकारले', this_month: 'या महिन्यात', active: 'सक्रिय', your_leave_balance_title: 'तुमची रजा शिल्लक', used: 'वापरले', pending: 'प्रलंबित',
    leave_dashboard: 'रजा डॅशबोर्ड', manage_track_leaves: 'तुमच्या रजांचे व्यवस्थापन करा', apply_for_leave: 'रजेसाठी अर्ज करा', team_calendar: 'टीम कॅलेंडर', on_leave_today: 'आज रजेवर', my_recent_requests: 'माझ्या अलीकडील विनंत्या', no_leave_requests: 'अद्याप रजा विनंत्या नाहीत', no_one_on_leave: 'आज कोणीही रजेवर नाही', submit_request: 'विनंती सादर करा', submitting: 'सादर करत आहे...', leave_type: 'रजा प्रकार', start_date: 'सुरू तारीख', end_date: 'शेवट तारीख', reason: 'कारण', reason_placeholder: 'रजेचे कारण...',
    sick_leave: 'आजारपणाची रजा', casual_leave: 'प्रासंगिक रजा', vacation: 'सुट्टी', earned_leave: 'अर्जित रजा', maternity_leave: 'मातृत्व रजा', paternity_leave: 'पितृत्व रजा', unpaid_leave: 'बिनपगारी रजा', compensatory: 'भरपाई रजा',
    announcements: 'सूचना', manage_announcements: 'शाळा सूचना व्यवस्थापित करा', create_announcement: 'सूचना तयार करा', announcement_title: 'शीर्षक', announcement_message: 'संदेश', priority: 'प्राधान्य', publish: 'प्रकाशित करा', publishing: 'प्रकाशित करत आहे...', active_announcements: 'सक्रिय सूचना', past_announcements: 'मागील सूचना', no_announcements: 'कोणतीही सूचना नाही', delete: 'हटवा', info: 'माहिती', warning: 'इशारा', urgent: 'तातडी',
    organization_chart: 'संस्था चार्ट', members: 'सदस्य', expand_all: 'सर्व विस्तारित करा', collapse: 'संकुचित करा', all_departments: 'सर्व विभाग', click_node_info: 'माहितीसाठी कोणत्याही नोडवर क्लिक करा', view_full_profile: 'पूर्ण प्रोफाइल पहा',
    save_changes: 'बदल जतन करा', saving: 'जतन करत आहे...', cancel: 'रद्द करा', edit: 'संपादित करा', search: 'शोधा', loading: 'लोड होत आहे...', back: 'मागे', no_data: 'डेटा आढळला नाही',
  },
  ur: {
    nav_dashboard: 'ڈیش بورڈ', nav_leave_dashboard: 'چھٹی ڈیش بورڈ', nav_my_profile: 'میری پروفائل', nav_analytics: 'تجزیات', nav_approvals: 'منظوریاں', nav_staff_directory: 'عملے کی فہرست', nav_org_chart: 'تنظیمی چارٹ', nav_team_calendar: 'ٹیم کیلنڈر', nav_staff_management: 'عملے کا انتظام', nav_leave_policies: 'چھٹی کی پالیسیاں', nav_workflows: 'ورک فلو', nav_school_branding: 'اسکول برانڈنگ', nav_announcements: 'اعلانات', nav_billing: 'بلنگ', nav_documents: 'دستاویزات', navigation: 'نیویگیشن',
    logout: 'لاگ آؤٹ', language: 'زبان', notifications: 'اطلاعات', mark_all_read: 'سب پڑھا ہوا', no_notifications: 'کوئی اطلاعات نہیں',
    welcome_back: 'واپسی پر خوش آمدید', school_overview: 'آپ کے اسکول میں کیا ہو رہا ہے', your_leave_balance: 'آپ کی چھٹی کا بیلنس', total_staff: 'کل عملہ', pending_requests: 'زیر التوا درخواستیں', awaiting_approval: 'منظوری کا انتظار', approved: 'منظور', rejected: 'مسترد', this_month: 'اس مہینے', active: 'فعال', your_leave_balance_title: 'آپ کی چھٹی کا بیلنس', used: 'استعمال شدہ', pending: 'زیر التوا',
    leave_dashboard: 'چھٹی ڈیش بورڈ', manage_track_leaves: 'اپنی چھٹیوں کا انتظام کریں', apply_for_leave: 'چھٹی کے لیے درخواست', team_calendar: 'ٹیم کیلنڈر', on_leave_today: 'آج چھٹی پر', my_recent_requests: 'میری حالیہ درخواستیں', no_leave_requests: 'ابھی تک کوئی چھٹی کی درخواست نہیں', no_one_on_leave: 'آج کوئی چھٹی پر نہیں', submit_request: 'درخواست جمع کرائیں', submitting: 'جمع ہو رہا ہے...', leave_type: 'چھٹی کی قسم', start_date: 'شروع کی تاریخ', end_date: 'اختتام کی تاریخ', reason: 'وجہ', reason_placeholder: 'چھٹی کی وجہ...',
    sick_leave: 'بیماری کی چھٹی', casual_leave: 'اتفاقی چھٹی', vacation: 'تعطیل', earned_leave: 'کمائی ہوئی چھٹی', maternity_leave: 'زچگی کی چھٹی', paternity_leave: 'والدیت کی چھٹی', unpaid_leave: 'بلا تنخواہ چھٹی', compensatory: 'تلافی چھٹی',
    announcements: 'اعلانات', manage_announcements: 'اسکول کے اعلانات کا انتظام', create_announcement: 'اعلان بنائیں', announcement_title: 'عنوان', announcement_message: 'پیغام', priority: 'ترجیح', publish: 'شائع کریں', publishing: 'شائع ہو رہا ہے...', active_announcements: 'فعال اعلانات', past_announcements: 'پچھلے اعلانات', no_announcements: 'کوئی اعلان نہیں', delete: 'حذف', info: 'معلومات', warning: 'انتباہ', urgent: 'فوری',
    organization_chart: 'تنظیمی چارٹ', members: 'ممبران', expand_all: 'سب پھیلائیں', collapse: 'سمیٹیں', all_departments: 'تمام شعبے', click_node_info: 'معلومات کے لیے کسی نوڈ پر کلک کریں', view_full_profile: 'مکمل پروفائل دیکھیں',
    save_changes: 'تبدیلیاں محفوظ کریں', saving: 'محفوظ ہو رہا ہے...', cancel: 'منسوخ', edit: 'ترمیم', search: 'تلاش', loading: 'لوڈ ہو رہا ہے...', back: 'واپس', no_data: 'کوئی ڈیٹا نہیں ملا',
  },
};

const LANGUAGE_LABELS = {
  en: 'English',
  hi: 'हिन्दी',
  kn: 'ಕನ್ನಡ',
  ta: 'தமிழ்',
  mr: 'मराठी',
  ur: 'اردو',
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('ariskool_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('ariskool_lang', lang);
    const isRtl = lang === 'ur';
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    document.body.style.direction = isRtl ? 'rtl' : 'ltr';
    document.body.style.textAlign = isRtl ? 'right' : 'left';
  }, [lang]);

  const resetLanguage = () => {
    setLang('en');
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('lang', 'en');
    document.body.style.direction = 'ltr';
    document.body.style.textAlign = 'left';
    localStorage.setItem('ariskool_lang', 'en');
  };

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGE_LABELS, resetLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
